export const heroImage =
  'https://cdn.magicpatterns.com/uploads/3E2ZNisXAhvg2SN1gbYz1x/heylloyd-generated-1790890386399-Photoroom.webp'

/** Link di pagamento. */
export const checkoutUrl =
  'https://pallamano-360.impultienda.ar/checkout'
export const brandName = 'PALLAMANO 360™'
export const price = '€19'
export const fullPrice = '€197'
export const volumesValue = '€120'
export const bonusValue = '€77'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '6', label: 'Volumi tecnici' },
  { value: '72', label: 'Sessioni da 60 minuti' },
  { value: '5', label: 'Bonus operativi' },
]

export const heroBadges: string[] = [
  '100% digitale',
  'Accesso immediato',
  'PDF scaricabile',
  'Garanzia 7 giorni',
]

/** Il costo reale di non avere il sistema corretto. */
export interface Cost {
  title: string
  detail: string
}

export const costs: Cost[] = [
  {
    title: 'Ore di preparazione ogni settimana',
    detail: 'Il lavoro inizia molto prima di entrare in campo.',
  },
  {
    title: 'Ripeti gli stessi esercizi',
    detail: 'Non perché siano i migliori, ma perché li ricordi più in fretta.',
  },
  {
    title: 'Esercizi senza una progressione chiara',
    detail: 'Il giocatore non capisce cosa viene prima e cosa dopo.',
  },
  {
    title: 'Spieghi troppo e mostri poco',
    detail: 'Un gesto si capisce molto meglio quando si può vedere.',
  },
  {
    title: "Vedi l'errore ma improvvisi la correzione",
    detail: 'Sai che qualcosa non va, ma devi decidere al volo come intervenire.',
  },
  {
    title: 'Livelli diversi nello stesso gruppo',
    detail: 'Troppo facile per alcuni, troppo difficile per altri.',
  },
  {
    title: 'Ogni allenamento ricomincia da zero',
    detail: 'Nessuna struttura collega una seduta alla successiva.',
  },
]

/** La logica con cui il sistema organizza il lavoro. */
export const systemFlow: string[] = [
  'Movimento',
  'Controllo della palla',
  'Passaggio & ricezione',
  'Tiro & 1 contro 1',
  'Collaborazione',
  'Gioco',
]

/** Cosa include l'accesso completo. */
export const included: string[] = [
  '6 volumi tecnici',
  '72 sessioni da 60 minuti',
  '5 bonus operativi',
  'Progressioni visuali passo dopo passo',
  'Esercizi illustrati',
  'Diagrammi e organizzazione del campo',
  'Errori e correzioni',
  'Coaching cues',
  '100% digitale',
  'Accesso immediato in PDF',
  'Garanzia di 7 giorni',
]

/** La chiusura: cosa succede se continui a improvvisare e cosa ottieni. */
export interface Outcome {
  text: string
  positive: boolean
}

export const outcomes: Outcome[] = [
  { text: 'Ore a cercare nuovi esercizi', positive: false },
  { text: "Progressioni costruite all'ultimo momento", positive: false },
  { text: "Spiegazioni lunghe durante l'allenamento", positive: false },
  {
    text: 'Esercizi scelti senza sapere cosa dovrebbe venire dopo',
    positive: false,
  },
  {
    text: 'Giocatori fermi mentre organizzi il prossimo lavoro',
    positive: false,
  },
  {
    text: 'Difficoltà ad adattare il lavoro ai diversi livelli',
    positive: false,
  },
  { text: 'Ogni seduta ricomincia da zero', positive: false },
  { text: '5 minuti per scegliere la struttura della seduta', positive: true },
  {
    text: 'Progressioni dal gesto semplice alla situazione di gioco',
    positive: true,
  },
  { text: 'Esercizi spiegati visualmente', positive: true },
  { text: '72 sessioni da 60 minuti già organizzate', positive: true },
  { text: 'Varianti per gruppi e livelli differenti', positive: true },
  { text: 'Errori e correzioni pronti da consultare', positive: true },
  { text: 'Più struttura e meno improvvisazione', positive: true },
]
